import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserInfo from '../components/Users/UserInfo';
import { getUserData } from "./../actions/user";
// import { getUser } from './../selectors/users';
let isEmptyObject = require('is-empty-object')

class CustomerContainer extends Component {
    isEmpty = (obj) => {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }
    state = {
        customer: {}
    }
    componentDidMount() {
        if (isEmptyObject(this.props.user)) {
            /* this.props.getUserData(this.props.authenticate.vusk, 'cedule').then(r => {
            }) */
        
        }

        if (!this.isEmpty(this.props.user)) {
            const { NumeroCliente } = this.props.user
            this.props.getBalanceUser({NumeroCliente, SecuencialEmpresa: 1}).then( res => {
                this.filterAccounts(false)
            })
            .catch(err=> {
                //console.log(' error al obtener balances ', err)
            })
        }
        
        
        /* client.service('balances').get(this.props.user.number).then(balance => {
            this.setState({customer: balance})
        }) */
        // this.fetchFromRemote('000000001')
    }

    render() {
        const { classes, user, authenticate, credits, balances, skeleton, deposits, verificates, parameters, balancesjoint/* , creditsDetails */ } = this.props
        // const { customer } = this.state
        return <UserInfo
                    skeleton = { skeleton }
                    customer = { user }
                    classes = { classes }
                    //chart = { chart }
                    balances = {balances}
                    balancesjoint = {balancesjoint}
                    authenticate = {authenticate}
                    deposits = { deposits }
                    credits = {credits}
                    /* creditsDetails = {creditsDetails} */
                    verificates = {verificates}
                    parameters = {parameters}
                />
    }
}

CustomerContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

/* const mapDispatchToProps = state => ({ 
    user: getUser(state)
}) */
 


export default connect(null , { getUserData })(CustomerContainer);